import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/warning.svg` */
export const WarningIcon = createTripletGlyphIcon('WarningIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.0109 11.17C8.34205 11.1703 8.61051 11.4394 8.61051 11.7706C8.61031 12.1017 8.34193 12.37 8.0109 12.3702C7.67966 12.3702 7.41052 12.1018 7.41032 11.7706C7.41032 11.4393 7.67953 11.17 8.0109 11.17Z"
        fill="currentColor"
      />
      <path
        d="M8.00895 5.53235C8.3127 5.53235 8.55973 5.77937 8.55973 6.08313V9.98254C8.55973 10.2863 8.3127 10.5323 8.00895 10.5323C7.70541 10.5321 7.45914 10.2861 7.45914 9.98254V6.08313C7.45914 5.77954 7.70541 5.53261 8.00895 5.53235Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.56657 2.31751C7.14589 1.22581 8.70789 1.21784 9.29801 2.30383L14.6808 12.2159C15.2417 13.2487 14.4937 14.5058 13.3185 14.506H2.6818C1.51342 14.506 0.764509 13.2619 1.31168 12.2296L6.56657 2.31751ZM8.33121 2.82922C8.1599 2.51399 7.70648 2.5163 7.53824 2.83313L2.28434 12.7452C2.12554 13.0449 2.34261 13.4054 2.6818 13.4054H13.3185C13.6595 13.4053 13.8766 13.0411 13.714 12.7413L8.33121 2.82922Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.01004 12.5667C9.38284 12.5667 9.68582 12.8687 9.68582 13.2415C9.68569 13.6142 9.38276 13.9163 9.01004 13.9163C8.63752 13.9161 8.33537 13.6141 8.33524 13.2415C8.33524 12.8689 8.63744 12.567 9.01004 12.5667Z"
        fill="currentColor"
      />
      <path
        d="M9.012 6.15071C9.31558 6.15092 9.5618 6.39786 9.5618 6.7015V11.2259C9.5618 11.5295 9.31558 11.7755 9.012 11.7757C8.70824 11.7757 8.46122 11.5297 8.46122 11.2259V6.7015C8.46122 6.39774 8.70824 6.15071 9.012 6.15071Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.44754 2.63997C8.07341 1.45951 9.76204 1.45114 10.3997 2.62532L16.4554 13.7757C17.0612 14.8918 16.2527 16.2503 14.9827 16.2503H3.01688C1.75445 16.2503 0.945588 14.9068 1.53641 13.7913L7.44754 2.63997ZM9.43289 3.15071C9.21399 2.74762 8.63406 2.75033 8.41922 3.1556L2.50809 14.306C2.30532 14.6889 2.58353 15.1507 3.01688 15.1507H14.9827C15.4185 15.1507 15.6963 14.6842 15.4886 14.3011L9.43289 3.15071Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0156 16.7549C12.5126 16.7549 12.9159 17.1583 12.9159 17.6553C12.9159 18.1523 12.5126 18.5547 12.0156 18.5547C11.5187 18.5546 11.1162 18.1522 11.1161 17.6553C11.1161 17.1584 11.5187 16.7551 12.0156 16.7549Z"
        fill="currentColor"
      />
      <path
        d="M12.0146 8.20122C12.4287 8.20122 12.7644 8.53715 12.7646 8.95122V14.9512C12.7646 15.3654 12.4288 15.7012 12.0146 15.7012C11.6005 15.701 11.2646 15.3653 11.2646 14.9512V8.95122C11.2647 8.53727 11.6006 8.20142 12.0146 8.20122Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.91595 3.51275C10.7566 1.92695 13.0242 1.91506 13.8808 3.49224L21.955 18.3604C22.7689 19.8596 21.6834 21.6836 19.9775 21.6836H11.9999H4.02239C2.32654 21.6835 1.24001 19.8784 2.03411 18.3799L9.91595 3.51275ZM12.5624 4.20806C12.2768 3.68254 11.5214 3.68643 11.2411 4.2149L3.35931 19.0831C3.09516 19.5824 3.45739 20.1835 4.02239 20.1836H19.9775C20.5461 20.1836 20.9079 19.5759 20.6367 19.0762L12.5624 4.20806Z"
        fill="currentColor"
      />
    </svg>
  ),
});
